import { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

export const useGA4 = (measurementId: string) => {
  const location = useLocation();

  useEffect(() => {
    if (measurementId) {
      ReactGA.initialize(measurementId);
    }
  }, [measurementId]);

  const currentPage = useMemo(() => {
    return location.pathname + location.search;
  }, [location.pathname, location.search]);

  useEffect(() => {
    if (measurementId && currentPage) {
      ReactGA.send({
        hitType: "pageview",
        page: currentPage,
      });
    }
  }, [currentPage, measurementId]);
};
